document.addEventListener("DOMContentLoaded", function () {
// ================= START :  Color Swatch append  JS =============================
const quickShopObserver = new MutationObserver(() => {
  const container = document.querySelector("#quickshop .product__details");
  if (!container) return;

  const swatches = container.querySelector(".pl-swatches-collection");
  const formBlock = container.querySelector(".product-block--form");

  if (swatches && formBlock && !swatches.dataset.moved) {
    formBlock.parentNode.insertBefore(swatches, formBlock);
    swatches.dataset.moved = "true";

    const swatchContainer = swatches.querySelector(".pl-swatches-collection__container");
    if (!swatchContainer) return;

    let label = swatches.querySelector(".custom-colour-label");
    if (!label) {
      label = document.createElement("div");
      label.className = "custom-colour-label";
      label.style.marginBottom = "6px";

      // Create the static text
      const textNode = document.createTextNode("Select color: ");
      label.appendChild(textNode);

      // Create the span for the dynamic color
      const colorSpan = document.createElement("span");
      colorSpan.className = "color-name";
      label.appendChild(colorSpan);

      swatchContainer.parentNode.insertBefore(label, swatchContainer);
    }

    const colorSpan = label.querySelector(".color-name");

    const updateLabel = () => {
      const active = swatches.querySelector('.pl-swatches-collection__link[aria-current="true"]');
      const colour = active?.getAttribute("title") || "";
      colorSpan.textContent = colour;
    };

    updateLabel();

    swatches.addEventListener("click", e => {
      if (e.target.closest(".pl-swatches-collection__link")) {
        setTimeout(updateLabel, 50);
      }
    });
  }
});


  quickShopObserver.observe(document.body, { childList: true, subtree: true });

// ================= END :  Color Swatch append  JS =============================

// ================= START :  Select Dropdownn JS =============================

document.addEventListener("change", function(e) {
  const select = e.target.closest(".js-quick-shop .product_section .product_dropdown #select_number");
  if (!select) return;
  const wrapper = select.closest(".product_section");
  if (!wrapper) return;
  const valueBox = wrapper.querySelector(".custom-option-value");
  if (!valueBox) return;
  const selectedText = select.options[select.selectedIndex].text;
  valueBox.textContent = selectedText;
});

document.addEventListener("change", function(e) {
  const lengthSelect = e.target.closest(".js-quick-shop .product_section .product_dropdown #chain_length");
  if (lengthSelect) {
    const selectedValue = lengthSelect.value;
    const customOption = lengthSelect.closest(".js-quick-shop").querySelector(".custom-chain-option-value");
    if (customOption) {
      customOption.textContent = selectedValue;
    }
  }
});

document.addEventListener("change", function(e) {
  const select = e.target.closest(".js-quick-shop .product_section .product_dropdown #select_color");
  if (!select) return;
  const wrapper = select.closest(".product_section");
  if (!wrapper) return;
  const valueBox = wrapper.querySelector(".custom-color-option-value");
  if (!valueBox) return;
  const selectedText = select.options[select.selectedIndex].text;
  valueBox.textContent = selectedText;
});



// ================= END :  Select Dropdownn JS =============================

// ================ START : QUick view Loader JS ====================
 const buttons = document.querySelectorAll('.custom-plp-quickview .quick_shop');
    buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            btn.classList.add('loading');
            const interval = setInterval(function() {
                const lightboxes = document.querySelectorAll('.fancybox-container.quick-shop__lightbox');
                if (lightboxes.length > 0) {
                    btn.classList.remove('loading');
                    clearInterval(interval);
                }
            }, 100); 
        });
    });

// ================ END : QUick view Loader JS ====================



// ========================== START: Quick View Add TO cart Button Load JS  ============================

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".custom-plp-add-to-cart");
    if (!btn) return;

    e.preventDefault();
    btn.classList.add("loading");

    const waitForDrawer = setInterval(() => {
      const drawer = document.querySelector(".cc_cart_drawer");

      if (!drawer) return;

      clearInterval(waitForDrawer);
      btn.classList.remove("loading");

      const text_error = document.querySelector(".text_error_info");

      const front = document.querySelector("#front_engraving");
      const back = document.querySelector("#back_engraving");

      const frontVal = front?.value.trim() || "";
      const backVal = back?.value.trim() || "";

      const selectedOption = document.querySelector(
        'input[name="location"]:checked'
      )?.value;

      const errorVisible =
        text_error &&
        window.getComputedStyle(text_error).display !== "none";

      if (errorVisible) {
        if (selectedOption === "front" && !frontVal) return;
        if (selectedOption === "back" && !backVal) return;
        if (selectedOption === "both" && (!frontVal || !backVal)) return;
      }

      const quickShopBtn = document.querySelector(
        ".js-quick-shop .fancybox-button"
      );

      if (quickShopBtn) quickShopBtn.click();
    }, 800);
  });


  document.addEventListener("click", async function(e){
    const btn = e.target.closest(".custom-plp-product-wrap .variant-add-cart-btn");
    if(!btn) return;
    e.preventDefault();
    const variantId =
      btn.dataset.variantId ||
      btn.closest("form")?.querySelector('[name="id"]')?.value;
    if(!variantId) return;
    btn.classList.add("loading");
    try{
      await fetch("/cart/add.js", {
        method:"POST",
        headers:{ "Content-Type":"application/json" },
        body: JSON.stringify({ id: variantId, quantity:1 })
      });
      const res = await fetch("/cart?view=drawer");
      const html = await res.text();
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const newDrawer = temp.querySelector(".cc_cart_drawer");
      const currentDrawer = document.querySelector(".cc_cart_drawer");
      if(newDrawer && currentDrawer){
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.classList.add("open");
      }
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("cart:open"));

    }catch(err){
      console.error("Cart error:", err);
    }finally{
      btn.classList.remove("loading");
    }
  });

// ========================== END: Quick View Add TO cart Button Load JS  ============================
// Function to wrap a title and its price
function wrapProductInfo(title, price) {
    // Prevent double-wrapping
    if (title.closest('.custom-product-info-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-product-info-wrapper';
    title.parentNode.insertBefore(wrapper, title);
    wrapper.appendChild(title);
    wrapper.appendChild(price);
}

// Use MutationObserver for dynamic content
const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach(() => {
        const products = document.querySelectorAll('.js-quick-shop .container .one-half.product__details');
        products.forEach(product => {
            const title = product.querySelector('.product-block--title');
            const price = product.querySelector('.product-block--price');
            if (title && price) {
                wrapProductInfo(title, price);
            }
        });
    });
});

// Start observing the body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

// Initial run for existing products
document.querySelectorAll('.js-quick-shop .container .one-half.product__details').forEach(product => {
    const title = product.querySelector('.product-block--title');
    const price = product.querySelector('.product-block--price');
    if (title && price) {
        wrapProductInfo(title, price);
    }
});



// ================ START : Quick View Product Load JS =========================

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.pl-swatches-collection__link');
  const quickShopContainer = document.querySelector('.js-quick-shop');
  if (!swatch) return;
  e.preventDefault();
  const productUrl = swatch.getAttribute('href');
  if (!productUrl) return;
  quickShopContainer.classList.add('loading');
  window.productPage
    .loadQuickshop(productUrl)
    .then(data => {
        if (!data || !data.html) return;
        if (!quickShopContainer) return;
        quickShopContainer.innerHTML = data.html.content;
        if ($.fancybox.getInstance()) {
          $.fancybox.close(true);
        }
        $.fancybox.open($('.js-quick-shop'), {
          baseClass: 'quick-shop__lightbox',
          hash: false,
          infobar: false,
          toolbar: false,
          loop: false,
          smallBtn: true,
          touch: false,
          afterShow: function (instance, current) {
            const $quickshop = $(current.src);
            if (window.productPage) {
              window.productPage.init();
              window.productPage.runOptionSelector($quickshop);
              window.productPage.productSwatches();
            }
            $quickshop
              .find('.quick-shop')
              .addClass('quick-shop--loaded content-loaded');
          }
        });

     setTimeout(() => {
      quickShopContainer.classList.remove('loading');
      }, 3100);

    })
    .catch(error => {
 quickShopContainer.classList.add('loading');
      console.error('Quickshop error:', error);
    });

});

// ================ END : Quick View Product Load JS =========================



//=================== Start :  Click event for quickview button =================

//=================== to initialize productData variable to query stock and variant id on change of dropdown
var qvProductData;
document.addEventListener("click", async function (e) {
  
  const swatch = e.target.closest('.pl-swatches-collection__link');
  if (!swatch) return;

  try {
    const response = await fetch(swatch.getAttribute('href') + ".js", {
      cache: "no-store"
    });

    if (!response.ok) throw new Error("Network error");

    qvProductData = await response.json();

  } catch (error) {
    console.error("Error fetching product:", error);
  } finally {
  }

});
//=================== to RESET productData variable to query stock and variant id on change of COLOR =====
document.addEventListener("click", async function (e) {

  const btn = e.target.closest(".js-quick-shop-link");
  if (!btn) return;

  if (btn.classList.contains("is-loading")) return;

  btn.classList.add("is-loading");

  try {
    const response = await fetch(btn.dataset.url + ".js", {
      cache: "no-store"
    });

    if (!response.ok) throw new Error("Network error");

    qvProductData = await response.json();

    // 👉 open modal here

  } catch (error) {
    console.error("Error fetching product:", error);
  } finally {
    btn.classList.remove("is-loading");
  }

});

//=================== End :  Click event for quickview button =================

//=================== Start :  Click event for dropdowns =================

document.addEventListener("change", function(e){
  const dropdown = e.target.closest('select[data-variant-id]');
  if(!dropdown) return;

  const quickView = dropdown.closest('.quick-shop__lightbox');
  if(!quickView) return;

  const idInput = quickView.querySelector('[name="id"]');
  const addBtn = quickView.querySelector('[data-btn-add-to-cart-v2]');
  const dropdowns = quickView.querySelectorAll('select[data-variant-id]');

  let selectedValues = [...dropdowns].map(d => d.value);
  let selected_variant = null;
  if(selectedValues.length == 2){
    selected_variant = qvProductData.variants.find(v =>
      v.option1.toLowerCase().includes(selectedValues[0].toLowerCase()) &&
      v.option2.toLowerCase().includes(selectedValues[1].toLowerCase())
    );

  } else {
    selected_variant = qvProductData.variants.find(v => v.id == dropdown.value);
  }
  if(!selected_variant) return;

  const textNode = Array.from(addBtn.childNodes)
  .find(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "");

    if (textNode) {
        textNode.nodeValue = selected_variant.available
          ? "Add to Cart "
          : "Sold Out ";
    }

  // stock
  if(selected_variant.available){
    addBtn.removeAttribute("data-out-of-stock");
  } else {
    addBtn.setAttribute("data-out-of-stock", true);
  }

  // variant id update
  idInput.value = selected_variant.id;
  addBtn.setAttribute("variant_id", selected_variant.id);

  // price update
  const price = quickView.querySelector('.product_price_text.product_price_main');
  if(price){
    price.innerHTML = Shopify.formatMoney(
      selected_variant.price,
      document.body.getAttribute("data-money-format")
    );
  }
});

// ============= End : Click event for dropdowns ================


  window.addEventListener('click', (event) => {
    if(event.target.classList.contains('engraving_container') || event.target.closest('.engraving_container')) { 
    //engraving_product
    let engraving_price_value = document.querySelector('.engraving_price_value');
    let font_style = document.querySelector('[name="font_style"]:checked');
    let location = document.querySelector('[name="location"]:checked');
    let engraving_elements = document.querySelectorAll('[data-engraving-text ] .form_item');
    let variant;
      if(location.value == 'front') {
        variant = engraving_product.variants[1];
        for(let i = 0; i < engraving_elements.length; i++) {
        let current_element = engraving_elements[i];
        if(current_element.querySelector('[id*="front"]')) {
          current_element.classList.remove('hidden-element');
        } else {
          current_element.classList.add('hidden-element');
        }
        }
      } else if(location.value == 'back') {
        variant = engraving_product.variants[1];
        for(let i = 0; i < engraving_elements.length; i++) {
          let current_element = engraving_elements[i];
          if(current_element.querySelector('[id*="back"]')) {
          current_element.classList.remove('hidden-element');
          } else {
          current_element.classList.add('hidden-element');
        }
          }

          } else if(location.value == 'both') {
            variant = engraving_product.variants[2];
            for(let i = 0; i < engraving_elements.length; i++) {
            let current_element = engraving_elements[i];
            current_element.classList.remove('hidden-element');
          }
      }
    }
    
  });

// ============= Start : quantity selector event for quickview ================
document.addEventListener("click", function (e) {

  const decreaseBtn = e.target.closest("#decrease");
  const increaseBtn = e.target.closest("#increase");

  if (decreaseBtn) {
    const wrapper = decreaseBtn.closest(".quantity-wrapper"); // optional if you wrap it
    const quantityInput = wrapper 
      ? wrapper.querySelector("#quantity") 
      : document.getElementById("quantity");

    if (!quantityInput) return;

    let currentValue = parseInt(quantityInput.value, 10) || 1;
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  }

  if (increaseBtn) {
    const wrapper = increaseBtn.closest(".quantity-wrapper");
    const quantityInput = wrapper 
      ? wrapper.querySelector("#quantity") 
      : document.getElementById("quantity");

    if (!quantityInput) return;

    let currentValue = parseInt(quantityInput.value, 10) || 1;
    quantityInput.value = currentValue + 1;
  }

});

// ============= End : quantity selector event for quickview ================

// ============= Start : product_gallery event for quickview ================

    (function(){

        function init(s){
        if(!s||s.dataset.sb)return;
        let vp=s.querySelector('.flickity-viewport'),
            i=s.querySelector('.flickity-slider');
        if(!vp||!i)return requestAnimationFrame(()=>init(s));
        s.dataset.sb=1;

        let bar=document.createElement('div'),
            t=document.createElement('div'),
            f=document.createElement('div');

        bar.style="margin:12px 15px 25px";
        t.style="height:6px;background:#eee;border-radius:10px;overflow:hidden;cursor:pointer";
        f.style="height:100%;width:0;background:#000";
        t.appendChild(f);bar.appendChild(t);s.after(bar);

        let flk=Flickity.data(s); 
        if(flk) flk.options.groupCells=false;

        function u(){
        let vw=vp.offsetWidth,tw=i.scrollWidth;
        if(tw<=vw)return f.style.width="100%";
        let x=getComputedStyle(i).transform;
        x=x!=="none"?Math.abs(new DOMMatrixReadOnly(x).m41):0;
        f.style.width=((vw/tw+(x/(tw-vw))*(1-vw/tw))*100)+"%";
        }

        t.onclick=e=>{
        let r=t.getBoundingClientRect(),
            p=(e.clientX-r.left)/r.width,
            fl=Flickity.data(s);
        fl&&fl.select(Math.round(p*(fl.slides.length-1)));
        };

        flk?.on('scroll',u);
        window.onresize=u;
        new MutationObserver(u).observe(i,{attributes:true});
        u();
        }

        new MutationObserver(()=>document.querySelectorAll('.product_gallery_nav').forEach(init))
        .observe(document.body,{childList:true,subtree:true});

    })();

    // ============= End : product_gallery event for quickview ================

});

